module.exports = __webpack_public_path__ + "static/img/quality04.17269ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quality04.jpg
// module id = /6NI
// module chunks = 1